const ApiEndPoint = {
    REGISTER_USER: '/register',
    REGISTER_USER_OTP: '/verifyOtp',
    REGISTER_RESENT_OTP: '/resendOtp',
    LOGIN_USER: '/login',
    LOGIN_SOCIAL: '/socialLogin',
    FORGOT_PASSWORD: '/forgot-password',
    FORGOT_RESENT_OTP: 'resend-otp',
    FORGOT_OTP_VERIFY: '/verify-otp',
    RESET_PASSWORD: '/reset-password',
    SAVE_CHAT_ID: '/createChatRoom',
    SAVE_PROFILE: '/profileUpdate',
    DELETE_ACCOUNT: '/deleteAccount',
    LOGOUT: '/logout',
    CHANGE_PASSWORD: '/changePassword',
    SUBJECT_LIST: '/subjectList',
    CHAT_ROOM_HISTORY: '/historyChatRoom',
    CHAT_HISTORY: '/historyChat',
    CHAT_UPDATE: '/createChat',
    CHAT_ROOM_RENAME: '/renameChatRoom',
    AI_CHAT: '/chat',
    CREATE_SUBSCRIPTION: '/create-subscription',
    GET_PLAN_LIST: '/plans',
    CREATE_CHECKOUT_SESSION: '/create-checkout-session',
    PAYMENT_STATUS: '/checkout-success',
    FEEDBACK_OPTION: '/feedback-option',
    SEND_FEEDBACK: '/feedback',
    FEEDBACK_FLOW: '/trial-feedback',
    SEND_CONTACT: '/contact',
    GENERATE_QUIZ: '/quiz-generate',
    SUBMIT_QUIZ: '/quiz-submission',
    SAMPLE_QUESTION: '/sampleQuestion',
    ACTIVE_PLAN: '/my-plan',
    CANCEL_SUBSCRIPTION: '/cancel-subscription',
    FAQS: '/faqs',
    TOGGLE_PINNED: '/togglePin',
    PAYMENT_HISTORY: '/paymentHistory',
}
Object.freeze(ApiEndPoint);
export default ApiEndPoint